import React from 'react';

import ChurnedUserReactivationButton from './ChurnedUserReactivationButton';
import PremiumText from './PremiumText';
import PremiumButton from './PremiumButton';
import { PremiumUpsells } from './types';

type Props = {
  premiumUpsells?: PremiumUpsells;
  isMobileNav: boolean;
  /** Autotest CTA label override (AutotestFocusedNav `ctaLabel` surface). */
  ctaLabel?: string | null;
};

const PremiumUpsellButton = ({
  premiumUpsells,
  isMobileNav,
  ctaLabel,
}: Props) => {
  if (premiumUpsells?.churnedUserReactivationDiscount) {
    return (
      <ChurnedUserReactivationButton
        discount={premiumUpsells?.churnedUserReactivationDiscount}
        isMobileNav={isMobileNav}
      />
    );
  }

  if (isMobileNav) {
    return (
      <PremiumText
        coupon={premiumUpsells?.halfOffCoupon}
        reactivate={premiumUpsells?.reactivatePremiumUpsellType}
        newUserDiscount={premiumUpsells?.newUserDiscount}
        trialPricingCopy={premiumUpsells?.trialPricingCopy}
        ctaLabel={ctaLabel}
      />
    );
  } else {
    return (
      <PremiumButton
        coupon={premiumUpsells?.halfOffCoupon}
        reactivate={premiumUpsells?.reactivatePremiumUpsellType}
        newUserDiscount={premiumUpsells?.newUserDiscount}
        trialPricingCopy={premiumUpsells?.trialPricingCopy}
        ctaLabel={ctaLabel}
      />
    );
  }
};

export default PremiumUpsellButton;
